import { render } from "./ActiveRent.vue?vue&type=template&id=1023a60a&scoped=true"
import script from "./ActiveRent.vue?vue&type=script&lang=js"
export * from "./ActiveRent.vue?vue&type=script&lang=js"

import "./ActiveRent.vue?vue&type=style&index=0&id=1023a60a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1023a60a"]])

export default __exports__